import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { logoutUser } from "../../hooks/logoutUser";
import { useState, useEffect, useRef } from "react";
import InactivityModal from "./InactivityModal";

const RequireAuth = () => {
  const { auth, setAuth } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
  ];
  const timerRef = useRef(null);
  const modalTimerRef = useRef(null);

  const INACTIVITY_TIME = 180000;

  useEffect(() => {
    if (isModalOpen) {
      setCountdown(30);
      clearInterval(modalTimerRef.current);

      modalTimerRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(modalTimerRef.current);
            logoutAction();
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [isModalOpen]);

  const resetInactivityTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsModalOpen(true);
    }, INACTIVITY_TIME);
  };

  // const logoutAction = () => {
  //   clearInterval(modalTimerRef.current); // Clear the countdown interval

  //   const deviceId = localStorage?.getItem("rehema_device_id");
  //   Object.keys(localStorage)?.forEach((key) => {
  //     if (key !== "rehema_device_id") {
  //       localStorage?.removeItem(key);
  //     }
  //   });

  //   if (deviceId) {
  //     localStorage?.setItem("rehema_device_id", deviceId);
  //   }
  //   setAuth({});
  //   window.location.pathname = "/";
  // };

  const logoutAction = () => {
    clearInterval(modalTimerRef.current);
    logoutUser(auth, setAuth); // ✅ centralized + full reset
  };

  const continueSession = () => {
    clearInterval(modalTimerRef.current); // Stop the countdown timer
    setIsModalOpen(false); // Close the modal
    resetInactivityTimer(); // Restart inactivity timer
  };

  useEffect(() => {
    const handleUserActivity = () => {
      if (isModalOpen) return; // Ignore user activity if the modal is open
      resetInactivityTimer();
    };

    events.forEach((event) =>
      window.addEventListener(event, handleUserActivity),
    );

    resetInactivityTimer(); // Initialize the inactivity timer

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleUserActivity),
      );
      clearTimeout(timerRef.current);
      clearInterval(modalTimerRef.current);
    };
  }, [isModalOpen]);

  const location = useLocation();

  return (
    <>
      <InactivityModal
        id="inactivityModal"
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        handleLogout={logoutAction}
        continueSession={continueSession}
        countdown={countdown}
      />
      {auth?.tokens?.accessToken ? (
        <Outlet />
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      )}
    </>
  );
};

export default RequireAuth;
